import Vue from 'vue';

Vue.filter('formatCurrencyEuro', function (value) {
    if (value) {
        return (value).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
    }
});